var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutreach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.894 0c3.063 0 7.691.94 9.846 3.094.546.546 1.26 1.615 1.26 3.182 0 2.786-2.245 7.06-4.723 9.54-1.281 1.28-3.32 2.956-6.062 2.956-2.68 0-4.727-1.821-5.32-2.414-2.269-2.27-3.895-5.716-3.895-8.928 0-2.026.578-3.8 2.052-5.273 1.365-1.367 3.718-2.157 6.842-2.157zm3.524 11.13c1.034-1.035 1.313-2.31 1.313-3.01 0-.509-.134-1.254-.77-1.89-.976-.975-2.055-1.25-3.23-1.25-1.489 0-2.489.47-3.155 1.136-.523.522-.974 1.326-.974 2.466s.608 2.242 1.27 2.905c.613.611 1.574 1.065 2.543 1.065.97 0 1.969-.388 3.003-1.422z",
    fill: "#5951ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutreach);
export default __webpack_public_path__ + "static/media/outreach.db73b9145bb2a49c44f7a547609ec32b.svg";
export { ForwardRef as ReactComponent };